import { useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import ApiService from "../../services/ApiService";

const Navbar = () => {

    const isAuthenticated = ApiService.isAthenticated();
    const isAdmin = ApiService.isAdmin();
    const isCustomer = ApiService.isCustomer();
    const isDeliveryPerson = ApiService.isDeliveryPerson();
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);

    const closeMenu = () => setMenuOpen(false);

    const handleLogout = () => {
        const isLogout = window.confirm("Are you sure you want to logout?")
        if (isLogout) {
            ApiService.logout();
            navigate("/login")
        }
        closeMenu();
    }

    // Helper to keep the className logic short and consistent everywhere
    const navLinkClass = ({ isActive }) => isActive ? "nav-link active" : "nav-link";

    return (
        <nav>
            <div className="logo">
                <NavLink to="/" className="logo-link" onClick={closeMenu} end>
                    Food App
                </NavLink>
            </div>

            <button
                className="hamburger-btn"
                onClick={() => setMenuOpen(!menuOpen)}
                aria-label="Toggle menu"
            >
                <span></span>
                <span></span>
                <span></span>
            </button>

            <div className={`desktop-nav ${menuOpen ? "open" : ""}`}>
                <NavLink to="/home" className={navLinkClass} onClick={closeMenu}>Home</NavLink>
                <NavLink to="/menu" className={navLinkClass} onClick={closeMenu}>Menu</NavLink>
                <NavLink to="/categories" className={navLinkClass} onClick={closeMenu}>Categories</NavLink>

                {isAuthenticated ? (
                    <>
                        {isCustomer && (
                            <>
                                <NavLink to="/orders" className={navLinkClass} onClick={closeMenu}>Orders</NavLink>
                                <NavLink to="/cart" className={navLinkClass} onClick={closeMenu}>Cart</NavLink>
                            </>
                        )}
                        {isDeliveryPerson && (
                            <NavLink to="/deliveries" className={navLinkClass} onClick={closeMenu}>Deliveries</NavLink>
                        )}
                        {isAdmin && (
                            <NavLink to="/admin" className={navLinkClass} onClick={closeMenu}>Admin</NavLink>
                        )}
                        <NavLink to="/profile" className={navLinkClass} onClick={closeMenu}>Profile</NavLink>
                        <button className="nav-button" onClick={handleLogout}>
                            Logout
                        </button>
                    </>
                ) : (
                    <>
                        <NavLink to="/login" className={navLinkClass} onClick={closeMenu}>Login</NavLink>
                        <NavLink to="/register" className={navLinkClass} onClick={closeMenu}>Register</NavLink>
                    </>
                )}
            </div>
        </nav>
    )

}
export default Navbar;